import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	searchIconLabel: {
		id: 'quick_find_dialog_aria_label',
		defaultMessage: 'Quick Find',
		description: 'Label text for search icon',
	},
	clearIconLabel: {
		id: 'input_clear_icon_label',
		defaultMessage: 'Clear',
		description: 'Label text for clear icon',
	},
	inputPlaceholderDefault: {
		id: 'input_placeholder_default',
		defaultMessage: 'Search for anything',
		description: 'Placeholder text in primary search input',
	},
	inputPlaceholderWithAtlassianIntelligence: {
		id: 'input_placeholder_with_atlassian_intelligence',
		defaultMessage: 'Search or ask anything',
		description: 'Placeholder text in primary search input with Atlassian Intelligence',
	},
	inputPlaceholderWithRovo: {
		id: 'input_placeholder_with_rovo',
		defaultMessage: 'Search or ask Rovo',
		description: 'Placeholder text in primary search input with Rovo',
	},
	inputPlaceholderNav3: {
		id: 'input_placeholder_nav3',
		defaultMessage: 'Search',
		description: 'Placeholder text in primary search input for Nav3',
	},
});
